import * as types from "../service/types";

const InitState = {
  loading: false,
  listTransactions: "",
  error: "",
};
const ListTransactionReducer = (state = InitState, action) => {
  switch (action.type) {
    case types.LIST_TRANSACTION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.LIST_TRANSACTION_SUCCESS:
      return {
        loading: false,
        listTransactions: action.payload,
        error: "",
      };
    case types.LIST_TRANSACTION_ERROR:
      return {
        loader: false,
        listTransactions: "",
        error: action.payload,
      };
    default:
      return state;
  }
};

export default ListTransactionReducer;